import { useEffect, useState } from 'react';
import { Link, NavLink, Outlet, useParams } from 'react-router-dom';
import { getPlatformTenant, type Tenant } from '../../lib/witness-api';

export interface PlatformTenantOutletContext { readonly tenant: Tenant }

export function PlatformTenantLayout() {
  const { tenantId = '' } = useParams<{ tenantId: string }>();
  const [state, setState] = useState<{ tenant?: Tenant | null; error?: string }>({});
  useEffect(() => {
    getPlatformTenant(tenantId)
      .then((tenant) => setState({ tenant }))
      .catch((error: unknown) => setState({ error: error instanceof Error ? error.message : 'Request failed' }));
  }, [tenantId]);

  if (state.error) return <p className="text-sm text-red-700">Failed to load tenant: {state.error}</p>;
  if (state.tenant === undefined) return <p className="text-sm text-neutral-500">Loading tenant…</p>;
  if (state.tenant === null) return <p className="text-sm text-neutral-600">Tenant not found. <Link className="underline" to="/platform/tenants">Back to tenants</Link></p>;
  const tenant = state.tenant;
  return <div className="flex flex-col gap-6">
    <div>
      <Link className="text-sm text-neutral-600 hover:text-neutral-900" to="/platform/tenants">← Tenants</Link>
      <h1 className="mt-3 font-serif text-3xl tracking-tight text-neutral-900">{tenant.displayName}</h1>
      <p className="mt-1 font-mono text-xs text-neutral-500">{tenant.id}</p>
    </div>
    <nav className="flex gap-1 border-b border-neutral-200">
      {[['', 'Overview'], ['memberships', 'Memberships']].map(([to, label]) =>
        <NavLink key={label} to={to} end={to === ''} className={({ isActive }) => `border-b-2 px-3 py-3 text-sm ${isActive ? 'border-neutral-900 font-medium text-neutral-900' : 'border-transparent text-neutral-600'}`}>{label}</NavLink>)}
    </nav>
    <Outlet context={{ tenant } satisfies PlatformTenantOutletContext} />
  </div>;
}

export function PlatformTenantOverviewPage() {
  return <div><h2 className="font-serif text-2xl">Overview</h2><p className="mt-1 text-sm text-neutral-600">Platform management for this tenant.</p></div>;
}
